export default class WallboardSubjectData {
  constructor(data) {
    this.title = `${data.tema}${data.categoria ? ` - ${data.categoria}` : ''}${
      data.assunto ? ` - ${data.assunto}` : ''
    }`
    this.info = data.d_0
  }
}
